import Vue from 'vue';
import Notifications from 'vue-notification';
import Initialization from './components/Initialization.vue';
import MachineRegistrationCreation from './components/MachineRegistrationCreation.vue';
import store from './store/store';
Vue.config.performance = true;
Vue.use(Notifications);
var vueInstance = new Vue({
    store: store,
    components: {
        Initialization: Initialization,
        MachineRegistrationCreation: MachineRegistrationCreation
    }
});
vueInstance.$mount('#machineRegistrationCreation');
